import { FC } from "react"
import { TravelersDeleteSuccess } from "../../../module/travelers/containers/deleteSuccess"

export const TravelersDeleteSuccessPage: FC = () => <TravelersDeleteSuccess />
